var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('el-amap',{staticClass:"map",attrs:{"mapStyle":_vm.mapStyle,"plugin":_vm.plugin,"center":_vm.center,"amap-manager":_vm.amapManager,"zoom":_vm.zoom,"events":_vm.events,"resize-enable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }